// extracted by mini-css-extract-plugin
export var TitleContainer = "styles-module--TitleContainer--3avhu";
export var Heading = "styles-module--Heading--f37Q9";
export var Title = "styles-module--Title--S0z87";
export var TitleText = "styles-module--TitleText--17EZw";
export var TitleSmallText = "styles-module--TitleSmallText--3S5Cn";
export var Header = "styles-module--Header--uFasu";
export var Header_Container = "styles-module--Header_Container--2yPIP";
export var Header_Logo = "styles-module--Header_Logo--2xhC6";
export var BannerAndTitle = "styles-module--BannerAndTitle--1GwYd";